const options = {
    add: false
};
export default options;
